import Text1 from './Text1'
export default Text1
